type ColumnHeaderInfoBtnText = {
  ariaLabel?: string;
};

export interface ResourceTableInfoButtonProps {
  text: ColumnHeaderInfoBtnText;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
}

export const ColumnHeaderInfoButton = ({
  text,
  onClick,
  onKeyDown,
}: ResourceTableInfoButtonProps): JSX.Element => {
  return (
    <button
      className="resourceTableHeaderIconBtn"
      onClick={onClick}
      tabIndex={0}
      aria-label={text.ariaLabel}
      onKeyDown={onKeyDown}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 1.5C11.5879 1.5 14.5 4.41214 14.5 8C14.5 11.5879 11.5879 14.5 8 14.5C4.41214 14.5 1.5 11.5879 1.5 8C1.5 4.41214 4.41214 1.5 8 1.5ZM8 1.90039C4.63686 1.90039 1.90039 4.63686 1.90039 8C1.90039 11.3631 4.63686 14.0996 8 14.0996C11.3631 14.0996 14.0996 11.3631 14.0996 8C14.0996 4.63686 11.3631 1.90039 8 1.90039ZM8.2002 7.7998V10.5996H8.90039V11H7.7998V8.2002H7.09961V7.7998H8.2002ZM8.2002 5V5.40039H7.7998V5H8.2002Z"
          fill="#F4F4F4"
          stroke="#F4F4F4"
        />
      </svg>
    </button>
  );
};
